import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";
import { API_BASE_URI } from "../ApiCall";
import { PettyCashReplenishmentActionTypes } from "./PettyCashReplenishment.type";

export function* fetchAllPettyCashReplenishmentSaga(action: any): any {
  try {
    const response = yield axios.get(`${API_BASE_URI}/petty-cash-replenishment`);
    yield put({
      type: PettyCashReplenishmentActionTypes.FETCH_ALL_PETTY_CASH_REPLENISHMENT_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: PettyCashReplenishmentActionTypes.FETCH_ALL_PETTY_CASH_REPLENISHMENT_FAILURE,
      payload: error,
    });
  }
}

export function* fetchOnePettyCashReplenishmentSaga(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/petty-cash-replenishment/${action?.payload?.id}`
    );
    yield put({
      type: PettyCashReplenishmentActionTypes.FETCH_ONE_PETTY_CASH_REPLENISHMENT_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: PettyCashReplenishmentActionTypes.FETCH_ONE_PETTY_CASH_REPLENISHMENT_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllPettyCashReplenishment() {
  yield takeLatest(
    PettyCashReplenishmentActionTypes.FETCH_ALL_PETTY_CASH_REPLENISHMENT,
    fetchAllPettyCashReplenishmentSaga
  );
}

export function* watcherFetchOnePettyCashReplenishment() {
  yield takeLatest(
    PettyCashReplenishmentActionTypes.FETCH_ONE_PETTY_CASH_REPLENISHMENT,
    fetchOnePettyCashReplenishmentSaga
  );
}
